import React, { createContext, useContext } from 'react';
import mapboxgl from 'mapbox-gl';
import { PlatmapControl } from '@mono/types/src/platmap';

export interface PlatmapMouseEvent {
    features: mapboxgl.MapboxGeoJSONFeature[];
    normalizedPoint: [number, number];
    wxtilesV3Values: { layerId: string; datum?: number[] }[];
    coordinates: { lat: number; lon: number };
    mouseCoordinates: { x: number; y: number };
}
export type OnMouseEvent = (props: PlatmapMouseEvent) => void;

interface PlatmapContextInterface {
    onViewportChanged?: (viewport: { bbox: [number, number, number, number]; center: [number, number]; zoom: number }) => void;
    onClick?: OnMouseEvent;
    onHover?: OnMouseEvent;
    onRightClick?: OnMouseEvent;
    setIsFlying?: (isFlying: boolean) => void;
    onChangeTopLabel?: (label: string) => void;
    onChangeTimezone?: (timezone: string) => void;
    onChangeTimeOffset?: (timeOffset: string) => void;
    onChangeTimeUnit?: (timeUnit: string) => void;
    controls: PlatmapControl[];
    targetDestination?: { center: [number, number]; zoom: number };
    viewportKey?: string;
}
interface PlatmapContextProps {
    children: React.ReactNode;
    onViewportChanged?: (viewport: { bbox: [number, number, number, number]; center: [number, number]; zoom: number }) => void;
    onClick?: OnMouseEvent;
    onHover?: OnMouseEvent;
    onRightClick?: OnMouseEvent;
    setIsFlying?: (isFlying: boolean) => void;
    onChangeTopLabel?: (label: string) => void;
    onChangeTimezone?: (timezone: string) => void;
    onChangeTimeOffset?: (timeOffset: string) => void;
    onChangeTimeUnit?: (timeUnit: string) => void;
    targetDestination?: { center: [number, number]; zoom: number };
    controls?: PlatmapControl[];
    viewportKey?: string;
}
export const PlatmapContext = createContext<PlatmapContextInterface>({
    setIsFlying: () => {},
    targetDestination: undefined,
    controls: [],
});

export const PlatmapContextProvider = ({
    children,
    onViewportChanged,
    onClick,
    setIsFlying,
    onHover,
    onRightClick,
    onChangeTopLabel,
    onChangeTimezone,
    onChangeTimeOffset,
    onChangeTimeUnit,
    controls = [],
    targetDestination,
    viewportKey,
}: PlatmapContextProps) => {
    return (
        <PlatmapContext.Provider
            value={{
                onViewportChanged,
                onClick,
                setIsFlying,
                onHover,
                onRightClick,
                onChangeTopLabel,
                onChangeTimezone,
                onChangeTimeOffset,
                onChangeTimeUnit,
                targetDestination,
                controls,
                viewportKey,
            }}
        >
            {children}
        </PlatmapContext.Provider>
    );
};

export const usePlatmapContext = () => useContext(PlatmapContext);
